module.exports = __webpack_public_path__ + "img/image6.70ad24dd.png";